import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Events } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { AudioProvider } from 'ionic-audio';
import { UserService } from '../providers/user-service';
import { ControlsService } from '../providers/controls-service';

@Injectable()
export class AudioService {
  currentTrack: any;
  currentTrackNumber: number = 0;
  currentEpisodeId: any;
  isPlaying: Boolean = false;

  constructor(
    public events: Events,
    public userService: UserService,
    public controlsService: ControlsService,
    public audioProvider: AudioProvider,
  ) {
    console.log('Hello AudioService Provider');
    // todo: crash if not set?
    this.currentTrack = {
      src: 'https://archive.org/download/swrembel2010-03-07.tlm170.flac16/swrembel2010-03-07s1t05.mp3',
      artist: '',
      title: 'Select a podcast & press listen to start',
      art: 'assets/img/Stephane.jpg',
      preload: 'metadata'
    };
    // listening for events
    events.subscribe('user:login', () => {
      this.userLoggedIn();
    });
    events.subscribe('track:playpause', () => {
      this.persistPlaybackData(0);
      this.playPauseCurrentTrack();
    });
    events.subscribe('track:finished', () => {
      this.isPlaying = false;
      this.controlsService.setIsPlaying(false);
      this.controlsService.destroy();
    });
    events.subscribe('track:back30s', () => {
      this.back30s();
    });
    events.subscribe('track:skip30s', () => {
      this.skip30s();
    });
  }

  userLoggedIn() {
    // starting playback persisting observation
    Observable.timer(1000, 10000)
      .subscribe((ticks) => {
        this.persistPlaybackData(ticks);
      });
  }

  persistPlaybackData(ticks) {
    // at least waiting a few seconds of playback before persisting data
    if ((this.isPlaying) && (this.currentTrack.progress > 10)) {
      const episodeId = this.currentEpisodeId;
      const progress = this.currentTrack.progress;
      this.userService.persistPlaybackData(episodeId, progress)
        .subscribe((data) => {
          console.log('persistPlaybackData', episodeId, progress);
        });
    }
  }

  playPauseCurrentTrack() {
    if (this.isPlaying) {
      this.audioProvider.tracks[this.currentTrackNumber].pause();
      this.isPlaying = false;
      this.controlsService.setIsPlaying(false);
    } else {
      // play first track if none was playing
      this.audioProvider.tracks[this.currentTrackNumber].play();
      this.isPlaying = true;
      this.controlsService.setIsPlaying(true);
    }
  }

  pause() {
    this.audioProvider.tracks[this.currentTrackNumber].pause();
    this.isPlaying = false;
    this.controlsService.setIsPlaying(false);
  }

  playTrack(track, paused = false) {
    if (this.isPlaying) {
      this.isPlaying = false;
    }
    // wipe track list
    if (this.audioProvider.tracks.length !== 0) {
      // destroying all existing tracks
      this.audioProvider.tracks.forEach((t) => {
        // stopping and destroying track
        t.stop();
        t.destroy();
      });
      // cleaning array
      this.audioProvider.tracks.splice(0);
    }
    // insert new track
    this.audioProvider.add(this.audioProvider.create(track));
    this.currentTrackNumber = 0;
    // switching track
    this.currentTrack = this.audioProvider.tracks[this.currentTrackNumber];
    if (!paused) {
      // play new track
      this.audioProvider.tracks[this.currentTrackNumber].play();
      // flag isPlaying
      this.isPlaying = true;
      // create controls for lock screen
      this.controlsService.create(track);
    }
    // playback persist
    if (track._id) {
      this.currentEpisodeId = track._id;
      // check if any progress has been persisted on server for this episode
      this.userService.fetchPlaybackData(this.currentEpisodeId)
        .subscribe((data: any) => {
          console.log('fetchPlaybackData', data);
          if ((data) && (data.progress)) {
            // if any progress data found, seek to position
            const self = this;
            // workaround on ios to wait for player to start
            // TODO: is there any way to observe if the player is ready?
            setTimeout(() => {
              self.audioProvider.tracks[self.currentTrackNumber].seekTo(data.progress);
            }, 5000);
          }
        });
    }
  }

  seekTo(pos) {
    if (this.audioProvider.tracks.length !== 0) {
      this.audioProvider.tracks[this.currentTrackNumber].seekTo(pos);
      this.controlsService.setElapsed(pos);
    }
  }

  back30s() {
    var pos = this.currentTrack.progress;
    pos = pos - 30;
    if (pos >= 0) {
      let track = this.audioProvider.tracks[this.currentTrackNumber];
      let roundedPos = Math.ceil(pos);
      track.seekTo(roundedPos);
      this.controlsService.setElapsed(roundedPos);
    }
  }

  skip30s() {
    var pos = this.currentTrack.progress;
    pos = pos + 30;
    if (pos <= this.currentTrack.audio.duration) {
      let track = this.audioProvider.tracks[this.currentTrackNumber];
      let roundedPos = Math.floor(pos);
      track.seekTo(roundedPos);
      this.controlsService.setElapsed(roundedPos);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/audio-service.ts